import { withBemMod } from '@bem-react/core';
import { cnToolsSuggest } from '../ToolsSuggest';
import './ToolsSuggest_size_m.css';
export var withSizeM = withBemMod(cnToolsSuggest(), { size: 'm' });
